module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/banner/vi-229413c8dc2403bbb8e190a152d1a76b.jpg";